function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 2.5C8.35156 2.5 8.65625 2.6875 8.82031 2.99219L13.8828 12.3672C14.0469 12.6484 14.0469 13 13.8594 13.3047C13.6953 13.5859 13.3906 13.75 13.0625 13.75H2.9375C2.60938 13.75 2.30469 13.5859 2.14062 13.3047C1.95312 13 1.95312 12.6484 2.11719 12.3672L7.17969 2.99219C7.34375 2.6875 7.64844 2.5 8 2.5ZM8 10.75C7.57812 10.75 7.25 11.0781 7.25 11.5C7.25 11.9219 7.57812 12.25 8 12.25C8.42188 12.25 8.75 11.9219 8.75 11.5C8.75 11.0781 8.42188 10.75 8 10.75ZM8 6.25C7.57812 6.25 7.22656 6.625 7.27344 7.04688L7.4375 9.48438C7.46094 9.76562 7.69531 10 8 10C8.30469 10 8.53906 9.76562 8.5625 9.48438L8.72656 7.04688C8.77344 6.625 8.42188 6.25 8 6.25Z",
  fill: "#F9A825"
});

function SvgWarningFilledIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningFilledIcon);
export default __webpack_public_path__ + "static/media/warning-filled-icon.f97ace15.svg";
export { ForwardRef as ReactComponent };